import { message }    from '@widesk-ui/hooks/useMessage';
import { UploadFile } from 'antd/es/upload';
import { RcFile }     from 'antd/es/upload';

export function convertAspectStringToFloat(aspect: string): number {
	const numbers = aspect.split('/');
	if (numbers.length !== 2 || !numbers[0] || !numbers[1]) {
		message.error(`L'aspect de l'image n'est pas correctement formaté.`);
		return 1;
	}

	return parseInt(numbers[0]) / parseInt(numbers[1]);
}

export function getFileDimension(file: File): Promise<{ width: number, height: number }> {
	return new Promise(resolve => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.addEventListener('load', event => {
			const _loadedImageUrl = event.target?.result;
			const image = document.createElement('img');
			image.src = _loadedImageUrl as string;

			image.addEventListener('load', () => {
				const { width, height } = image;
				resolve({ width, height });
			});
		});
	});
}

export function toBase64(file: UploadFile | File): Promise<string> {
	return new Promise((resolve, reject) => {
			const reader = new FileReader();

			reader.readAsDataURL(file as RcFile);
			reader.onload = () => resolve(reader.result as string);
			reader.onerror = (error) => reject(error);
		},
	);
}